import { cardRef, defineGameCard, onResolve, planningTargets, tableTarget, targetStep, } from '../authoring/index.js';
import { parseCellId } from '@cards/engine';
import { plannedTableId } from './plant-helpers.js';
export const EmbroideredCoverCard = defineGameCard({
    id: 'embroidered_cover',
    gameplay: {
        type: 'SPELL',
        cost: 4,
        planning: planningTargets([
            targetStep('location', tableTarget({ cardinality: { min: 1, max: 1 } })),
        ]),
    },
    presentation: {
        name: 'Чехол с вышивкой',
        description: 'Все карты в выбранной локации получают Щит 2.',
        glyph: {
            colors: ['#10213A', '#213A57', '#E6A542', '#9E2D23', '#1C3149'],
            rows: [
                '....................',
                '..1111111111111111..',
                '.122222222222222221.',
                '.121222222222222211.',
                '.121222222122222221.',
                '.122221133431112221.',
                '.112213334443332221.',
                '..11214444444432211.',
                '..11214444344432211.',
                '..15214433333432221.',
                '..11223444344412211.',
                '..11223444344412221.',
                '..12221444344322251.',
                '..11222144443222211.',
                '..12.22213432222.51.',
                '..11122222122222151.',
                '..1151.222222.21551.',
                '..1155125.22515551..',
                '...11111111111111...',
                '....................',
            ],
        },
    },
    role: 'playable',
    dependencies: [cardRef('embroidered_cover')],
    abilities: [
        onResolve((ctx) => {
            const tableId = plannedTableId(ctx, 'location');
            if (tableId === undefined || ctx.self === undefined)
                return;
            for (const target of ctx.q.allUnits()) {
                if (target.cellId !== undefined && parseCellId(target.cellId).tableId === tableId) {
                    ctx.ops.addShield(EmbroideredCoverCard.id, target.id, 2, ctx.self.id);
                }
            }
        }),
    ],
    ui: {
        mechanics: ['shield'],
        planning: {
            steps: { location: { label: 'Выберите локацию' } },
        },
    },
});
//# sourceMappingURL=embroidered_cover.js.map